import cn from 'classnames/bind'

import { isValueZero } from './isValueZero'
import { isValueNegative } from './isValueNegative'
import { isValuePositive } from './isValuePositive'
import styles from './render-cell-gray-zeros-red-conditions.module.scss'

const cx = cn.bind(styles)

interface PropsCells {
  columnKey: string
  value?: string | Array<string> | null
  isRedNegative?: boolean
  isRedPositive?: boolean
}

export const renderCellGrayZerosRedConditions = <CellData extends PropsCells>(
  cellData?: CellData,
) => {
  if (!cellData) {
    return <span>{'Поле не задано'}</span>
  }

  const { value, isRedNegative, isRedPositive } = cellData

  if ('value' in cellData) {
    const zero = isValueZero(value)
    const negativeValue = isRedNegative && isValueNegative(value)
    const positiveValue = isRedPositive && isValuePositive(value)
    return (
      <span className={cx(styles.root, { zero, redConditions: negativeValue || positiveValue })}>
        {value === null ? '—' : value}
      </span>
    )
  }

  return <span>{'—'}</span>
}
